import { useEffect } from 'react';
import useAuthStore from '@/store/Auth';
import WebAppService from '@/services/WebAppService';

const ONE_HOUR = 3600000;

export default function useCreditCheck(isMobile: boolean) {
  const { organization, setCreditMessage } = useAuthStore();

  useEffect(() => {
    if (!organization?.id || isMobile) return;

    const check = async () => {
      try {
        const response = await WebAppService.checkOrganizationCredits();
        if (response?.message) setCreditMessage(response.message);
      } catch (error) {
        console.error('Credit check failed:', error);
      }
    };

    // Run immediately
    check();

    // Then every hour
    const interval = setInterval(check, ONE_HOUR);

    // Also on tab re-focus
    const onVisibility = () => {
      if (!document.hidden) check();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [organization?.id, isMobile]);
}
